import { useRef } from "react";
import { StickerIcon } from "../../../../../svg";
import { useDispatch } from "react-redux";
import { addFiles } from "../../../../../features/chatSlice";

export default function StickerAttachment() {
  const dispatch = useDispatch();
  const inputRef = useRef(null);

  const stickerHandler = (e) => {
    let files = Array.from(e.target.files);
    files.forEach((file) => {
      if (file.type !== "image/webp") {
        files = files.filter((item) => item.name !== file.name);
        return;
      }
      if (file.size > 1024 * 1024 * 5) {
        files = files.filter((item) => item.name !== file.name);
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (ev) => {
        dispatch(
          addFiles({
            file,
            fileData: ev.target.result,
            type: "STICKER",
          })
        );
      };
    });
  };

  return (
    <li>
      <button
        type="button"
        className="rounded-full"
        onClick={() => inputRef.current.click()}
        title="ملصق"
        aria-label="ملصق"
      >
        <StickerIcon />
      </button>
      <input
        type="file"
        hidden
        ref={inputRef}
        accept="image/webp"
        onChange={stickerHandler}
      />
    </li>
  );
}
